import { useFormContext } from 'libs/form/useFormContext';

export const useIsFormEditable = () => {
  const { readOnly } = useFormContext();

  return !readOnly;
};
